<template>
  <div v-if="hasData" class="pedido-timeline">
    <div class="timeline-step">
      <div class="timeline-icon">
        <i class="feather icon-home" />
      </div>
      <span class="timeline-label">{{ origem }}</span>
    </div>
    <div class="timeline-line" />
    <div class="timeline-step">
      <div class="timeline-icon timeline-icon--truck">
        <i class="feather icon-truck" />
      </div>
      <span class="timeline-label">{{ transportadora }}</span>
    </div>
    <div class="timeline-line" />
    <div class="timeline-step">
      <div class="timeline-icon">
        <i class="feather icon-map-pin" />
      </div>
      <span class="timeline-label">{{ destino }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PedidoTimeline',
  props: {
    origem: {
      type: String,
      default: ''
    },
    transportadora: {
      type: String,
      default: ''
    },
    destino: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasData () {
      return !!(this.origem || this.transportadora || this.destino)
    }
  }
}
</script>

<style scoped>
.pedido-timeline {
  display: flex;
  align-items: center;
  padding: 12px 0;
  width: 100%;
}

.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.timeline-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #9A3092;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #9A3092;
}

.timeline-icon--truck {
  background: #9A3092;
  color: #fff;
}

.timeline-label {
  margin-top: 6px;
  font-size: 11px;
  color: #666;
  text-align: center;
  max-width: 80px;
  word-break: break-word;
  line-height: 1.3;
}

.timeline-line {
  flex: 1;
  height: 2px;
  background: #e0d4e8;
  min-width: 12px;
}

/* Dark mode */
body.dark-layout .pedido-timeline .timeline-icon {
  background: #283046;
  border-color: #b366b3;
  color: #b366b3;
}

body.dark-layout .pedido-timeline .timeline-icon--truck {
  background: #9A3092;
  color: #fff;
}

body.dark-layout .pedido-timeline .timeline-label {
  color: #b4b7bd;
}

body.dark-layout .pedido-timeline .timeline-line {
  background: #3b3052;
}
</style>
